// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"87ebebc5d4131a01fd87","777":"d2368104de90e03819ba"}[chunkId] + ".js";
};